import { computed } from 'vue';

function useBlockPositioning(className, cols, colsCentered, contentCentered) {
  const positioningClassNames = computed(() => ({
    [`${className}--max-cols-${cols}`]: true,
    [`${className}--cols-even`]: cols % 2 === 0,
    [`${className}--cols-odd`]: cols % 2 !== 0,
    [`${className}--cols-centered`]: colsCentered,
    [`${className}--content-centered`]: contentCentered
  }));
  return {
    positioningClassNames
  };
}

export { useBlockPositioning };
